class ViewMoreInteraction extends HHBaseElement {
  get targetBlockSelector() {
    return this.dataset.targetBlock
  }

  get targetBlocks() {
    return Array.from(this.querySelectorAll(this.targetBlockSelector)) || []
  }

  get controlCTA() {
    return this.querySelector('[data-view-more-control] button')
  }

  get controlCTAWrapper() {
    return this.querySelector('[data-view-more-control]')
  }

  get viewMoreCTA() {
    return this.dataset.viewMoreCta
  }

  get viewLessCTA() {
    return this.dataset.viewLessCta
  }

  get isExpanded() {
    return this.classList.contains('view-more-interaction--expanded')
  }

  connectedCallback() {
    this.observer = new MutationObserver(this._onMutation.bind(this))
    this.observer.observe(this, {
      childList: true,
      subtree: true,
      attributes: false,
    })
  }

  disconnectedCallback() {
    this.observer.disconnect()
  }

  _onMutation(mutations) {
    if (this.targetBlocks && this.targetBlocks.length > 0) {
      this._setup()
    }
  }

  _onControlClick(event) {
    event.preventDefault()
    this.toggle()
  }

  _setup() {
    const controlCTA = this.controlCTA
    if (controlCTA) {
      controlCTA.addEventListener('click', this._onControlClick.bind(this))
    }
    this.observer.disconnect()
    this._adjustBlocks()

    if (this.targetBlocks.length <= 3) {
      this.controlCTAWrapper.style.display = 'none'
    }
  }

  toggle() {
    this.classList.toggle('view-more-interaction--expanded')
    this.controlCTA.innerText = this.isExpanded
      ? this.viewLessCTA
      : this.viewMoreCTA

    this._adjustBlocks()
  }

  _adjustBlocks() {
    this.targetBlocks.forEach((block, index) => {
      if (this.isExpanded) {
        block.style.display = ''
      } else {
        block.style.display = index <= 2 ? '' : 'none'
      }
    })
  }
}

window.customElements.define('viewmore-interaction', ViewMoreInteraction)
